import React, { FC, memo } from 'react';
import { createPortal } from 'react-dom';
import { ErrorContainer } from '~/src/components/common-components/dropzone-uploader/dropzone-uploader.styles';
import { ErrorNotification } from '~/src/components/common-components/error-notification/error-notification';
import { getSizeErrorText } from '~/src/components/common-components/dropzone-uploader/dropzone-uploader.utils';
import {
    ERROR_FETCH,
    ERROR_TEXT_COUNTS,
    ERROR_TEXT_FORMAT,
} from '~/src/components/common-components/dropzone-uploader/dropzone-uploader.constants';
import type {
    DropConePortalErrorProps,
} from '~/src/components/common-components/dropzone-portal-error/dropzone-portal-error.types';

const DropZonePortalError: FC<DropConePortalErrorProps> = ({
    setIsErrorFormatData,
    isErrorFormatShow,
    setIsFetchErrorData,
    isFetchErrorShow,
    setIsErrorCountsData,
    limitedFiles,
    maxCountFiles,
    isErrorCountsShow,
    isErrorSizeShow,
    setIsErrorSizeData,
    portalRefCurrent,
    notificationPosition,
    maxSizeInMB,
}) => {
    const bodyFallbackElement = document?.querySelector('body') as HTMLElement;

    return createPortal(<ErrorContainer notificationPosition={notificationPosition}>
        {isErrorSizeShow ?
            <ErrorNotification
                callbackAfterShow={() => setIsErrorSizeData((prev) => ({ ...prev, showingError: false }))}
            >
                {getSizeErrorText(maxSizeInMB)}
            </ErrorNotification> : <></>}
        {isErrorCountsShow ?
            <ErrorNotification
                callbackAfterShow={() => setIsErrorCountsData((prev) => ({ ...prev, showingError: false }))}
            >
                <>{ERROR_TEXT_COUNTS}&nbsp;{maxCountFiles}&nbsp;{limitedFiles}</>
            </ErrorNotification> : <></>}
        {isFetchErrorShow ?
            <ErrorNotification
                callbackAfterShow={() => setIsFetchErrorData((prev) => ({ ...prev, showingError: false }))}
            >
                {ERROR_FETCH}
            </ErrorNotification> : <></>}
        {isErrorFormatShow ?
            <ErrorNotification
                callbackAfterShow={() => setIsErrorFormatData((prev) => ({ ...prev, showingError: false }))}
            >
                {ERROR_TEXT_FORMAT}
            </ErrorNotification> : <></>}
    </ErrorContainer>, portalRefCurrent || bodyFallbackElement);
};

export const DropZonePortalErrorMemo = memo(DropZonePortalError);